module.exports = __webpack_public_path__ + "img/Hypoxia-BRCA_10X_WTA.b037d086.png";